import { render } from "./IntegrationsList.vue?vue&type=template&id=765d1d78"
import script from "./IntegrationsList.vue?vue&type=script&lang=js"
export * from "./IntegrationsList.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__